import React from 'react'
import { Horizontal, Vertical, Texto, BBDTag } from '@gravitate-js/excalibrr'
import { Progress } from 'antd'
import { useDirectiveContext } from '../../DirectiveContext'
import { PricePerformance } from './PricePerformance'
import { EnvironmentFilled, ExperimentFilled, UserOutlined } from '@ant-design/icons'

export const SelectedPriceDetails = ({ selectedPrice, priceMetrics, metricsLoading }) => {
  const { selectedDirective } = useDirectiveContext()
  const volumePercentage =
    priceMetrics.directiveTotalVolume === 0
      ? 0
      : ((priceMetrics.priceTotalVolume / priceMetrics.directiveTotalVolume) * 100).toFixed()
  return (
    <>
      <Horizontal verticalCenter className='py-3 px-4 selected-price-header' background='bg-2' border='bottom'>
        <Horizontal flex={1} verticalCenter>
          <Texto weight='bold' appearance='medium'>
            DIRECTIVE GROUP
          </Texto>
          <BBDTag style={{ fontWeight: 'bold' }} className='ml-4' theme2>
            {selectedDirective?.name}
          </BBDTag>
        </Horizontal>
        <Horizontal verticalCenter flex={1}>
          <Texto align='right' className='flex-1' weight='bold' appearance='medium'>
            VOLUME PERCENTAGE
          </Texto>
          <Texto weight='bold' category='h6' className='pr-2 pl-4' appearance='secondary'>
            {volumePercentage}%
          </Texto>
          <Progress
            size='small'
            style={{ width: 120 }}
            showInfo={false}
            className='driver-scorecard'
            strokeWidth={10}
            strokeLinecap='square'
            percent={volumePercentage}
          />
        </Horizontal>
      </Horizontal>
      <Vertical background='bg-2' style={{ maxHeight: 150 }} border='bottom'>
        <Horizontal justifyContent='space-around' verticalCenter className='py-3 px-4' flex={1}>
          <Texto category='p2' weight='bold' className='flex-1' appearance='secondary'>
            <EnvironmentFilled className='pr-2' /> {selectedPrice.terminal}
          </Texto>
          <Texto category='p2' weight='bold' className='flex-1' appearance='secondary'>
            <UserOutlined className='pr-2' /> {selectedPrice.supplier}
          </Texto>
          <Texto category='p2' align='center' weight='bold' className='flex-1' appearance='secondary'>
            <ExperimentFilled className='pr-2' /> {selectedPrice.product}
          </Texto>
        </Horizontal>
        <PricePerformance metricsLoading={metricsLoading} directiveMetrics={priceMetrics?.priceData} />
      </Vertical>
    </>
  )
}
